import ReactGA from "react-ga4";

export const initGA = () => {
  ReactGA.initialize("G-6RVWQMRZWD"); 
};

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};
